import { Injectable } from '@angular/core';
import { ActionCableService, sharePublishReplay } from 'ngx-libs';
import { Market } from '../models/market';
import { AccountService } from './account.service';
import { ContractService } from './contract.service';
import { EthWalletService } from './eth-wallet.service';
import { MainService } from './main.service';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { ZToken } from '../models/z-token';

@Injectable({
  providedIn: 'root'
})
export class MarketService {
  markets: Observable<Market[]>;
  ethMarket: Observable<Market>;
  zTokens: Observable<ZToken[]>;

  constructor(
    private accountService: AccountService,
    private ethWalletService: EthWalletService,
    private contractService: ContractService,
    private actionCableService: ActionCableService,
    private mainService: MainService
  ) {
    const network = environment.networks.find((n) => n.contracts);
    this.markets = this.mainService.markets.query().pipe(
      map((json) =>
        json.markets.map(
          (m: any) =>
            new Market(
              m,
              network,
              this.accountService,
              this.ethWalletService,
              this.contractService,
              this.actionCableService,
              this.mainService
            )
        )
      ),
      sharePublishReplay(1)
    );

    this.ethMarket = this.markets.pipe(map((markets) => markets.find((m) => m.name === 'ETH-USDC')));

    this.zTokens = this.markets.pipe(
      map((markets) => {
        const map = new Map<string, ZToken>();
        markets.forEach((m) => map.set(m.collateral.contract, m.collateral));
        return Array.from(map.values());
      })
    );
  }
}
